import JSONApiClient from '../jsonapi-service';
import { authService } from '../auth-service';
import AxiosService from '../axios-service';

export function fetchUser(id) {
  const client = JSONApiClient();
  return client.get('users', id, { include: 'settings' })
    .then(user => user);
}

export function updateUser(id, fields) {
  const client = JSONApiClient();
  const { name, email, viewedOnboardingState } = fields;
  return client.get('users', id)
    .then(user => {
      if (name) user.set('name', name);
      if (email) user.set('email', email);
      if (viewedOnboardingState) user.set('viewedOnboardingState', viewedOnboardingState);
      return user.sync();
    });
}

export function saveUserSettings(userId, settings) {
  const client = JSONApiClient();

  return client.get('users', userId, {})
    .then(user => {
      user.relationships('settings').set(settings);
      return user.sync();
    });
}

export function createUserSettings(settingsData) {
  const client = JSONApiClient();

  const settings = client.create('settings');

  if (settingsData.emailType) settings.set('emailType', settingsData.emailType);
  if (settingsData.emailFrequency) settings.set('emailFrequency', settingsData.emailFrequency);

  return settings.sync()
    .then(response => {
      // Returns a resource not a JSON object
      return response;
    });
}

export function updateUserSettings(settingsId, settingsData) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}` });

  const attributes = {};
  if (settingsData.emailType) attributes.emailType = settingsData.emailType;
  if (settingsData.emailFrequency) attributes.emailFrequency = settingsData.emailFrequency;

  return axiosService.patch(`/settings/${settingsId}`, {
    data: {
      id: settingsId,
      type: 'settings',
      attributes,
    },
  })
  .then(response => {
    return response.data.data;
  });
}

export function updateUserTrackedVideos(userId, trackedVideo) {
  const client = JSONApiClient();

  return client.get('users', userId, {})
    .then(user => {
      user.relationships('trackedVideos').add(trackedVideo);
      return user.sync();
    });
}

function makeTrackedVideosQuery(userId) {
  const query = `
  query UsersTrackedVideoQuery {
    users(id: "${userId}") {
      id
      name
      trackedVideos {
        id
        youtubeId
        createdBy
        createdDate
        user {
          id
        }
        campaign {
          id
          name
        }
        discussion {
          id
          name
        }
      }
    }
  }
  `;
  return query;
}

export function getUserTrackedVideos(userId) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}` });

  const query = makeTrackedVideosQuery(userId);

  return axiosService.post('', {
    query,
    variables: null,
    operationName: null,
  })
  .then(response => {
    return response.data.data.users[0];
  });
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/users.js
 **/